module.exports = __webpack_public_path__ + "img/avatar.488d62a7.png";